import { AssistanceStatus } from '@/constants/portfolio.const';
import { OwnedAssistanceProduct } from '@/interfaces';
import { LIFESTYLE_FORDNCO, RoadsideProductType } from '../roadside-helpers';

export interface IRSAPolicyStatusRules {
  isActive: boolean;
  showPayNowButton: boolean;
  isOverDue: boolean;
  isExpiredOrLapse: boolean;
  renewalProducedInvoice: boolean;
  renewalProducedDirectDebit: boolean;
  reminderProducedInvoice: boolean;
  reminderProducedDirectDebit: boolean;
  pendingPayment: boolean;
  noVehicleInRsa: boolean;
  isFordNCO: boolean;
  isLifeStyle: boolean;
  isCMO: boolean;
}

export const getRsaPolicyStatusDetails = (roadsidePolicy: OwnedAssistanceProduct): IRSAPolicyStatusRules => {
  const result = {
    isOverDue:
      roadsidePolicy.status == AssistanceStatus.ReminderProduced ||
      roadsidePolicy.status == AssistanceStatus.Lapsed ||
      roadsidePolicy.status == AssistanceStatus.Expired,
    isActive: roadsidePolicy.status == AssistanceStatus.Activated,
    isExpiredOrLapse:
      roadsidePolicy.status == AssistanceStatus.Lapsed || roadsidePolicy.status == AssistanceStatus.Expired,
    renewalProducedDirectDebit:
      roadsidePolicy.status == AssistanceStatus.RenewalProduced && roadsidePolicy.isAutoPayment,
    renewalProducedInvoice: roadsidePolicy.status == AssistanceStatus.RenewalProduced && !roadsidePolicy.isAutoPayment,
    reminderProducedDirectDebit:
      roadsidePolicy.status == AssistanceStatus.ReminderProduced && roadsidePolicy.isAutoPayment,
    reminderProducedInvoice:
      roadsidePolicy.status == AssistanceStatus.ReminderProduced && !roadsidePolicy.isAutoPayment,
    pendingPayment: roadsidePolicy.status == AssistanceStatus.PendingPayment,
    noVehicleInRsa: roadsidePolicy.productLevel?.toLowerCase() == 'roadside assistance' && !roadsidePolicy.hasVehicle,
    isFordNCO: roadsidePolicy.productCode == LIFESTYLE_FORDNCO,
    isLifeStyle: roadsidePolicy.productCode == LIFESTYLE_FORDNCO || roadsidePolicy.isLifestyle,
    isCMO: roadsidePolicy.roadsidePolicyType == RoadsideProductType.Cmo,
  } as IRSAPolicyStatusRules;

  result.showPayNowButton = !result.isCMO && (result.renewalProducedInvoice || result.reminderProducedInvoice);
  return result;
};
